import {
    BASE_EXCEL_STYLES_ALIGNMENT,
    BASE_EXCEL_STYLES_BORDERS,
    BASE_EXCEL_STYLES_FILL,
    BASE_EXCEL_STYLES_FONT,
    BASE_EXPORT_HEADER_STYLES
} from "@containers/export/constants/baseExportStyles";
import {IColumnItem} from "@ui/tableCustom/types/columns";
import {
    SubTaskSingleVoyageTransformForTable,
    TaskSingleVoyageTransformForTable
} from "@containers/singleVoyage/tasks/table/types";
import {SubTaskSingleVoyage} from "@containers/singleVoyage/tasks/types";

export const FULL_COLUMNS_TASKS_SINGLE_VOYAGE: IColumnItem<TaskSingleVoyageTransformForTable>[] = [
    {
        title: 'base.name',
        id: 'title',
        exportStyles: {
            excel: {
                width: {
                    wch: 19,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 62
            }
        },
        exportStylesHeader: {
            excel: {
                border: BASE_EXCEL_STYLES_BORDERS,
                alignment: BASE_EXCEL_STYLES_ALIGNMENT,
                font: BASE_EXCEL_STYLES_FONT,
                fill: BASE_EXCEL_STYLES_FILL,
            },
        },
        uiStyles: {
            minWidth: '170px'
        }
    },
    {
        title: 'base.description',
        id: 'description',
        exportStyles: {
            excel: {
                width: {
                    wch: 15,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 40
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.points',
        id: 'waypoints',
        exportStyles: {
            excel: {
                width: {
                    wch: 15,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 40
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'singleVoyage.planCompletionTime',
        id: 'planCompletionTime',
        exportStyles: {
            excel: {
                width: {
                    wch: 11,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 58
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.template',
        id: 'taskConfigTemplateId',
        exportStyles: {
            excel: {
                width: {
                    wch: 14,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 65
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.status',
        id: 'status',
        exportStyles: {
            excel: {
                width: {
                    wch: 14,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 65
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },

]

export const FULL_COLUMNS_SUB_TASKS_SINGLE_VOYAGE: IColumnItem<SubTaskSingleVoyageTransformForTable>[] = [
    {
        title: 'base.name',
        id: 'title',
        exportStyles: {
            excel: {
                width: {
                    wch: 19,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 62
            }
        },
        exportStylesHeader: {
            excel: {
                border: BASE_EXCEL_STYLES_BORDERS,
                alignment: BASE_EXCEL_STYLES_ALIGNMENT,
                font: BASE_EXCEL_STYLES_FONT,
                fill: BASE_EXCEL_STYLES_FILL,
            },
        },
        uiStyles: {
            minWidth: '170px'
        }
    },
    {
        title: 'base.description',
        id: 'description',
        exportStyles: {
            excel: {
                width: {
                    wch: 15,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 40
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.points',
        id: 'waypoints',
        exportStyles: {
            excel: {
                width: {
                    wch: 15,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 40
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'singleVoyage.planCompletionTime',
        id: 'planCompletionTime',
        exportStyles: {
            excel: {
                width: {
                    wch: 11,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 58
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.template',
        id: 'taskConfigTemplateId',
        exportStyles: {
            excel: {
                width: {
                    wch: 14,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 65
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },
    {
        title: 'base.status',
        id: 'status',
        exportStyles: {
            excel: {
                width: {
                    wch: 14,
                },
                font: {
                    sz: '9',
                },
                border: BASE_EXCEL_STYLES_BORDERS,
            },
            pdf: {
                width: 65
            }
        },
        exportStylesHeader: BASE_EXPORT_HEADER_STYLES,
    },

]
